import Button from '2-core-elements/Buttons/Button';
import Select from '2-core-elements/FormElements/SelectCustom';
import { useState, type FC, type FormEvent } from 'react';
import { currencyFormat } from '../calculatorLibs';

interface FixedDeathCalcFormReturn {
    age: number;
    gender: 'male' | 'female';
    cover: number;
}

interface FixedDeathCalcFormProps {
    ageOptions: {
        label: string;
        value: string;
    }[];
    labels?: {
        ageLabel?: string;
        genderLabel?: string;
        coverLabel?: string;
        coverHelpText?: string;
        submitLabel?: string;
    };
    onSubmit: (options: FixedDeathCalcFormReturn) => void;
}

const generateCoverOptions = (): {
    label: string;
    value: string;
}[] => {
    const dataArray = [];

    const min = 10000;
    const max = 3000000;
    const increment = 10000;

    for (let i = min; i <= max; i += increment) {
        dataArray.push({
            label: currencyFormat.format(i),
            value: i.toString(),
        });
    }

    return dataArray;
};

const FixedDeathCalcForm: FC<FixedDeathCalcFormProps> = ({ ageOptions, labels = {}, onSubmit }) => {
    const {
        ageLabel = 'Age*',
        genderLabel = 'Gender*',
        coverLabel = 'Cover*',
        coverHelpText = '',
        submitLabel = 'Calculate',
    } = labels;

    const genderOptions = [
        {
            label: `Male`,
            value: `male`,
        },
        {
            label: `Female`,
            value: `female`,
        }
    ];

    const coverOptions = generateCoverOptions();

    const [selectedAge, setSelectedAge] = useState(ageOptions[0]);
    const [selectedGender, setSelectedGender] = useState(genderOptions[0]);
    const [selectedCover, setSelectedCover] = useState(() => {
        return coverOptions.find(item => {
            return item.value === '250000';
        });
    });

    const onFormSubmit = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault();

        onSubmit({
            age: parseInt(selectedAge.value),
            gender: selectedGender.value as FixedDeathCalcFormReturn['gender'],
            cover: selectedCover ? parseInt(selectedCover.value) : 0,
        });
    };

    return (
        <form className="form-calc" onSubmit={onFormSubmit}>
            <div className="form-group-calc">
                <label>{ageLabel}</label>
                {ageOptions && (
                    <Select
                        options={ageOptions}
                        value={selectedAge}
                        enableNull={false}
                        onChange={(option): void => {
                            if (option) {
                                setSelectedAge(option);
                            }
                        }}
                    />
                )}
            </div>
            <div className="form-group-calc">
                <label>{genderLabel}</label>
                <Select
                    options={genderOptions}
                    value={selectedGender}
                    enableNull={false}
                    onChange={(option): void => {
                        if (option) {
                            setSelectedGender(option);
                        }
                    }}
                />
            </div>
            <div className="form-group-calc">
                <label>{coverLabel}</label>
                <Select
                    options={coverOptions}
                    value={selectedCover}
                    enableNull={false}
                    onChange={(option): void => {
                        if (option) {
                            setSelectedCover(option);
                        }
                    }}
                />
                {coverHelpText && (
                    <div className="input-message">{coverHelpText}</div>
                )}
            </div>
            <div className="form-group-calc">
                <Button type="submit">{submitLabel}</Button>
            </div>
        </form>
    );
};

export default FixedDeathCalcForm;
